import React, {   useState } from 'react'
import {  Form, Input, App,Modal,} from 'antd'
import { useKehuAddMutation } from '../../store/DianShangYeWuApi';
import ClientTypeSelect from '../clientType/ClientTypeSelect';
import Icon from '../../cpn/Icon';
const { TextArea } = Input;
function ClientAdd(props) {
    // 如果外部传入了open和onClose，使用外部控制；否则使用内部状态
    const isControlled = props.open !== undefined && props.onClose !== undefined;
    const [internalOpen, setInternalOpen] = useState(false);
    const open = isControlled ? props.open : internalOpen;
    
    const{message} = App.useApp();    
    const [form] = Form.useForm(); 
    const [submit] = useKehuAddMutation();
    const [info,setInfo] = useState({
        'kh_qy_id': props.qy_id,
        'kh_qy_name': props.qy_name,
        'kh_name': '',
        'kh_cid': props.yh_id,
        'kh_cname': props.yh_name,
        'kh_type_id': '',
        'kh_type_name': '',
        'kh_remark': '',       
    })

    // 触发器：默认显示加号图标，如提供 triggerText 则使用文字链接
    const handleTriggerClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isControlled) {
            // 外部控制时，通过onClose通知外部打开
            if (typeof props.onClose === 'function') {
                props.onClose(true);
            }
        } else {
            setInternalOpen(true);
        }
    };
    
    const trigger = props.triggerText
        ? <a onClick={handleTriggerClick}>{props.triggerText}</a>
        : <Icon type='add' onClick={handleTriggerClick} />;

    const handleClose = () => {
        if (isControlled) {
            if (typeof props.onClose === 'function') {
                props.onClose(false);
            }
        } else {
            setInternalOpen(false);
        }
    };

    return (
        <>
            {!isControlled && trigger}
            <Modal
                open={open}
                title='新增客户'
                width={800}
                maskClosable={false}
                onCancel={handleClose} 
                onOk={() => {                    
                    submit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功')   
                            form.resetFields();  
                            handleClose();
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败：'+res.data.Message)
                        }
                    }) 
                }}            
            >
                <Form                                
                    form={form}
                    style={{width: '100%' }}
                    layout="horizonal"
                    name="form_client_add"
                    initialValues={{
                        modifier: 'public',
                    }}
                    labelCol={{ span: 5}}                                 
                >   
                     <ClientTypeSelect
                        name="kh_type_id"
                        label="客户类型"
                        required
                        wrapperCol={{span:10}}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,kh_type_id:e,kh_type_name:f}))
                        }}
                    />
                    <Form.Item name="kh_name" wrapperCol={{span:10}} required label='客户名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,kh_name:e.target.value}))
                        }}/>
                    </Form.Item>                   
                   
                    <Form.Item name="kh_remark" wrapperCol={{span:10}} label='备注'>                        
                        <TextArea onChange={(e) => {
                            setInfo(prevState=>({...prevState,kh_remark:e.target.value}))
                        }}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientAdd